<template>
  <div class="product-buy-info">
    <p>
      <template v-for="(line, index) in body" :key="index">
        <template v-if="line.lead">{{ line.lead }}</template>
        <a v-if="line.tel" class="product-buy-info_tel" :href="`tel:${line.tel}`">{{ line.text }}</a>
        <span v-else-if="line.red" class="product-buy-info_red">{{ line.text }}</span>
        <span v-else-if="line.redNote" class="red">{{ line.text }}</span>
        <span v-else-if="line.strong" class="w-strong">{{ line.text }}</span>
        <template v-else>{{ line.text }}</template>
        <template v-if="line.tail">{{ line.tail }}</template>
        <br v-if="index < body.length - 1" />
      </template>
    </p>
    <a v-if="link" :href="link.href" class="product-buy-info_toggle">
      {{ link.label }}
      <span class="product-buy-info_arrow"></span>
    </a>
  </div>
</template>

<script setup lang="ts">
import type { ProductDetailContentType } from '@/types/domains/index';
/**
 * 支給デザインの `product-buy-info`（購入枠の中の補足案内）。28/38。
 * 定期枠では「3回以上のご継続をお約束頂くコース となります。」＋「定期コースについて」への導線、
 * 通常枠では「おまとめ買いがお得です！」＋割引の内訳、という2通りの使い方をされている。
 *
 * **導線はアンカージャンプ**（`href="#regularInfo"`）。支給はクラス名が `_toggle` で開閉を思わせるが、
 * `data-target` が0件で JS が動かず、本文は価格比較表の下に常時表示されている。
 * 本文が購入枠から離れているためトグルでは画面外で開くことになる（→ §8-31 の案A）。
 *
 * **本文は行の配列**（決定#56）。支給38本の `product-buy-info` を全数集計すると **130行**あり、
 * 内訳は **素のテキスト66 ／ 強調＋続きのテキスト24 ／ `w-strong` が行全体18 ／
 * 電話リンクが行全体12 ／ `product-buy-info_red` が行全体8**。
 *
 * **行の一部だけを装飾する形は2通りある。** 定期枠の「N回以上のご継続をお約束頂くコース」＋
 * 「となります。」が24件（強調が行頭）と、**第7便で入った支払例の
 * 「4,980円 × 3回 ＝ 14,940円（税込）※送料当社負担」が20商品23行**（赤字が行末）。
 * したがって `lead`（装飾の前）＋ `text`（装飾部分）＋ `tail`（装飾の後ろ）の3つで表す。
 * どの形も `v-html` は要らない。
 *
 * **定期枠の強調はクラスの無い `<span>`。** 支給CSS の
 * `.product-buy-box_regular .product-buy-info span { font-weight: 600 }`（`renewal/style.css:6444`）で
 * 太くなる。`.w-strong` も 600（`:91`）なので `w-strong` を付けて描いても見た目は同じ。
 *
 * **赤字は2種類ある。** 行全体の `product-buy-info_red`（赤・600）と、支払例の行末に付く
 * `<span class="red">`（`.product-buy-box_regular .product-buy-info span.red` で赤・normal。
 * `renewal/style.css:6448`）。**太さが違うので同じものとして扱えない**ため `red` と `redNote` に分ける。
 *
 * **`product-buy-info_tel` は独立ブロックではない。** 支給では `product-buy-info` の本文中の
 * インラインリンク（`design-src/20260810/product-detail/productK41.html` ほか8商品
 * ＝`L61` `L62` `K41`〜`K45` `KG01`）。販売制限の2商品（`KG02` `KF15`）とは重複しない（決定#42）。
 *
 * **継続回数はハードコードしない。** 「3回以上」の3は商品別 const（`RegularCourseConst` の
 * `minCount`）を参照し、購入枠と本文（`#regularInfo`）で回数がずれるのを防ぐ（決定#47）。
 * → CONVERSION-GUIDE.md §3.3.1 の #7
 */
/**
 * 行の型は**ドメイン型を1つの出どころにする**（決定#5）。
 * 各フィールドの意味は `ProductBuyInfoLine` の docblock 参照。
 */
type Line = ProductDetailContentType.ProductBuyInfoLine;

type Props = {
  /** 本文。1要素＝1行 */
  body: Line[];
  /** 末尾の導線。無ければ省略 */
  link?: { href: string; label: string } | null;
};

withDefaults(defineProps<Props>(), {
  link: null,
});
</script>
